"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_ONLY_USER_SCOPES = exports.UserScope = exports.MANDATORY_SUBSCRIBED_CONTACT_AREAS = exports.ADMIN_ONLY_CONTACT_AREAS = exports.ContactArea = exports.Entity = exports.ROLE = void 0;
var Source;
(function (Source) {
    Source["SELF"] = "SELF";
    Source["INVITATION"] = "INVITATION";
})(Source || (Source = {}));
var ROLE;
(function (ROLE) {
    ROLE["ADMIN"] = "ADMIN";
    ROLE["NON_ADMIN"] = "NON_ADMIN";
})(ROLE = exports.ROLE || (exports.ROLE = {}));
var Entity;
(function (Entity) {
    Entity["ALL"] = "ALL";
    Entity["INBOUND"] = "INBOUND";
    Entity["INVENTORY"] = "INVENTORY";
    Entity["ORDER"] = "ORDER";
    Entity["BILLING"] = "BILLING";
    Entity["CHANNEL"] = "CHANNEL";
    Entity["REPORTS"] = "REPORTS";
})(Entity = exports.Entity || (exports.Entity = {}));
var ContactArea;
(function (ContactArea) {
    ContactArea["INBOUNDS"] = "INBOUNDS";
    ContactArea["NON_COMPLIANCE"] = "NON_COMPLIANCE";
    ContactArea["CLAIMS"] = "CLAIMS";
    ContactArea["ORDERS"] = "ORDERS";
    ContactArea["INVENTORY"] = "INVENTORY";
    ContactArea["REPLENISHMENT"] = "REPLENISHMENT";
    ContactArea["WHOLESALE"] = "WHOLESALE";
    ContactArea["RETURNS"] = "RETURNS";
    ContactArea["PREP"] = "PREP";
    ContactArea["PARCEL"] = "PARCEL";
    ContactArea["FREIGHT"] = "FREIGHT";
    ContactArea["BILLING"] = "BILLING";
    ContactArea["CHANNELS"] = "CHANNELS";
    ContactArea["PRODUCT"] = "PRODUCT";
    ContactArea["REPORTS"] = "REPORTS";
})(ContactArea = exports.ContactArea || (exports.ContactArea = {}));
exports.ADMIN_ONLY_CONTACT_AREAS = [ContactArea.CLAIMS, ContactArea.BILLING, ContactArea.CHANNELS];
exports.MANDATORY_SUBSCRIBED_CONTACT_AREAS = [ContactArea.CLAIMS, ContactArea.BILLING, ContactArea.CHANNELS];
var UserScope;
(function (UserScope) {
    UserScope["INBOUNDS_READ"] = "INBOUNDS_READ";
    UserScope["INBOUNDS_WRITE"] = "INBOUNDS_WRITE";
    UserScope["INBOUNDS_MAIL"] = "INBOUNDS_MAIL";
    UserScope["NON_COMPLIANCE_MAIL"] = "NON_COMPLIANCE_MAIL";
    UserScope["CLAIMS_MAIL"] = "CLAIMS_MAIL";
    UserScope["ORDERS_READ"] = "ORDERS_READ";
    UserScope["ORDERS_WRITE"] = "ORDERS_WRITE";
    UserScope["ORDERS_MAIL"] = "ORDERS_MAIL";
    UserScope["INVENTORY_READ"] = "INVENTORY_READ";
    UserScope["INVENTORY_WRITE"] = "INVENTORY_WRITE";
    UserScope["INVENTORY_MAIL"] = "INVENTORY_MAIL";
    UserScope["REPLENISHMENT_READ"] = "REPLENISHMENT_READ";
    UserScope["REPLENISHMENT_WRITE"] = "REPLENISHMENT_WRITE";
    UserScope["REPLENISHMENT_MAIL"] = "REPLENISHMENT_MAIL";
    UserScope["WHOLESALE_MAIL"] = "WHOLESALE_MAIL";
    UserScope["RETURNS_READ"] = "RETURNS_READ";
    UserScope["RETURNS_WRITE"] = "RETURNS_WRITE";
    UserScope["RETURNS_MAIL"] = "RETURNS_MAIL";
    UserScope["PREP_READ"] = "PREP_READ";
    UserScope["PREP_WRITE"] = "PREP_WRITE";
    UserScope["PREP_MAIL"] = "PREP_MAIL";
    UserScope["PARCEL_READ"] = "PARCEL_READ";
    UserScope["PARCEL_WRITE"] = "PARCEL_WRITE";
    UserScope["PARCEL_MAIL"] = "PARCEL_MAIL";
    UserScope["FREIGHT_READ"] = "FREIGHT_READ";
    UserScope["FREIGHT_WRITE"] = "FREIGHT_WRITE";
    UserScope["FREIGHT_MAIL"] = "FREIGHT_MAIL";
    UserScope["BILLING_READ"] = "BILLING_READ";
    UserScope["BILLING_WRITE"] = "BILLING_WRITE";
    UserScope["BILLING_MAIL"] = "BILLING_MAIL";
    UserScope["CHANNELS_MAIL"] = "CHANNELS_MAIL";
    UserScope["PRODUCT_MAIL"] = "PRODUCT_MAIL";
    UserScope["REPORTS_READ"] = "REPORTS_READ";
    UserScope["REPORTS_WRITE"] = "REPORTS_WRITE";
    UserScope["REPORTS_MAIL"] = "REPORTS_MAIL";
    UserScope["FAST_TAGS_WRITE"] = "FAST_TAGS_WRITE";
    UserScope["INTEGRATIONS_WRITE"] = "INTEGRATIONS_WRITE";
    UserScope["SETTINGS_WRITE"] = "SETTINGS_WRITE";
})(UserScope = exports.UserScope || (exports.UserScope = {}));
exports.ADMIN_ONLY_USER_SCOPES = [
    UserScope.CLAIMS_MAIL,
    UserScope.BILLING_READ,
    UserScope.BILLING_WRITE,
    UserScope.BILLING_MAIL,
    UserScope.CHANNELS_MAIL,
];
//# sourceMappingURL=User.js.map